'use strict';

//libraries
var React = require('react');
var SelectInput = require('../Common/SelectInput.jsx');
var ClassNames = require('classnames');
//store
var YourDetailsStore = require('../../stores/YourDetailsStore.js');
var YourDetailsHelpers = require('../../utils/YourDetailsHelpers');

var Country = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        placeholder: React.PropTypes.string,
        clearable: React.PropTypes.func,
        searchable: React.PropTypes.func,        
        value: React.PropTypes.string,
        onChange: React.PropTypes.func,
        errorList: React.PropTypes.array,
        disabled: React.PropTypes.bool,
        excludeCountryList: React.PropTypes.array,
        allowedCountryList: React.PropTypes.array,
        notes: React.PropTypes.string
    },
    getInitialState: function () {
        var exclude = this.props.excludeCountryList;
        var allowedList = this.props.allowedCountryList;
        var countries = YourDetailsStore.getCountryList().filter(function (el) { return !(exclude && exclude.indexOf(el.value) > -1) });

        if (allowedList && allowedList.length > 0)
        {
            countries = countries.filter(country => { return allowedList && allowedList.indexOf(country.value) > -1 });
        }   
        return { countryList: countries };
    },    
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },   
    _onChange: function () {
        var exclude = this.props.excludeCountryList;
        var allowedList = this.props.allowedCountryList;
        var countries = YourDetailsStore.getCountryList().filter(function (el) { return !(exclude && exclude.indexOf(el.value) > -1) });

        if (allowedList && allowedList.length > 0) {
            countries = countries.filter(country => { return allowedList && allowedList.indexOf(country.value) > -1 });
        }        
        this.setState({ countryList: countries });
    },
    handleCountryOnChange: function (event) {
        if (this.props.onBlur){
            event.target.value = YourDetailsHelpers.getCountryCode(event.target.value || '');
            this.props.onBlur(event);
        }
    },
    render: function () {
        return (    
                <SelectInput label={this.props.label}

                             className={ClassNames('select-country', this.props.className)}
                             id={this.props.id}
                             model={this.props.model}
                             options={this.state.countryList} 
                             clearable={this.props.clearable} 
                             searchable={this.props.searchable}
                             disabled={this.props.disabled}
                             value={this.props.value}
                             onChange={this.handleCountryOnChange}
                             onBlur={this.handleCountryOnChange}
                             inputProps={this.props.inputProps} 
                             helpText={this.props.helpText}
                             errorList={this.props.errorList}
                             mandatory={this.props.mandatory}
                             notes={this.props.notes} />
        );
    }
});
module.exports = Country;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Country.jsx